export {default as ModalTabs} from './modal-tabs.jsx';
